import { render, staticRenderFns } from "./CiVehicleMetadata.vue?vue&type=template&id=c7a75d7a&"
import script from "./CiVehicleMetadata.vue?vue&type=script&lang=js&"
export * from "./CiVehicleMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports